import { render, staticRenderFns } from "./InactiveCartItem.vue?vue&type=template&id=50326751&lang=pug&"
import script from "./InactiveCartItem.vue?vue&type=script&lang=js&"
export * from "./InactiveCartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports